import React, { useContext, useEffect, useState } from "react";
import PatientTable from "./patientTable";
import { getPatientRecords } from "../../../service/endpoint-manager";
import CreatePatientDialog from "./CreatePatientDialog";
import Loading from "../Shared/Loading";
import { SocketContext } from "../../../context/SocketContext";
import { AuthContext } from "../../../context/AuthContext";

const Patient = () => {
  const [patientData, setPatientData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [socketRefresh, setSocketRefresh] = useState(false);
  const socket = useContext(SocketContext);

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const transformPatientData = (patientDataToTransform) => {
    return {
      id: patientDataToTransform.id,
      Room: patientDataToTransform.room,
      NextRound: patientDataToTransform.nextRound,
      Patient: patientDataToTransform.patient,
      Provider: patientDataToTransform.provider,
      Nurse: patientDataToTransform.nurse,
      Aide: patientDataToTransform.aide,
      Precautions: patientDataToTransform.infotiles || [],
      Alerts: patientDataToTransform.alerts,
      RoomStatus: patientDataToTransform.roomStatus,
      Education: patientDataToTransform.educations,
      Color: patientDataToTransform.color,
      IsolationStartDate: patientDataToTransform.isolationStartDate,
    };
  };

  const handlePatientCreated = (newPatient) => {
    const transformedData = transformPatientData(newPatient.body);
    setPatientData([transformedData, ...patientData]);
  };

  //Emits the login event and if successful redirects to chat and saves user data
  useEffect(() => {
    if (socketRefresh) {
      socket.emit("message", { socketRefresh }, (error) => {
        if (error) {
          console.error(error);
        }
      });
      setSocketRefresh(false);
    }
  }, [socketRefresh]);

  // On 'message' refresh patient data
  useEffect(() => {
    socket.on("message", ({ msg }) => {
      if (msg) {
        fetchPatientData();
      }
    });
  }, [socket]);

  const fetchPatientData = async () => {
    try {
      setLoading(true);
      const response = await getPatientRecords();
      if (response && response.status === 200 && response.data.status) {
        const transformedData = response.data.body.map((item) =>
          transformPatientData(item)
        );

        setPatientData(transformedData);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPatientData();
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <PatientTable
        data={patientData}
        handleDialogOpen={handleDialogOpen}
        setSocketRefresh={setSocketRefresh}
      />
      <CreatePatientDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        onPatientCreated={handlePatientCreated}
      />
    </div>
  );
};

export default Patient;
